module.exports = __webpack_public_path__ + "static/media/Big Braids.418202da.svg";